import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex centered" }
const _hoisted_2 = { class: "col-lg-10 col-12" }
const _hoisted_3 = { class: "row" }

import SkillCard from '@/components/about/SkillCard.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SkillCards',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-lg-flex d-none align-items-center" }, [
      _createElementVNode("p", {
        "data-aos": "zoom-in",
        class: "skill__text"
      }, "Skills")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SkillCard, { name: "Java" }),
        _createVNode(SkillCard, {
          name: "C#",
          "icon-name": "c-sharp"
        }),
        _createVNode(SkillCard, { name: "Python" }),
        _createVNode(SkillCard, { name: "TypeScript" }),
        _createVNode(SkillCard, { name: "HTML" }),
        _createVNode(SkillCard, { name: "CSS" }),
        _createVNode(SkillCard, { name: "React" }),
        _createVNode(SkillCard, {
          name: "React Native",
          "icon-name": "react"
        }),
        _createVNode(SkillCard, { name: "Vue" }),
        _createVNode(SkillCard, {
          name: "Next",
          "add-image-padding": ""
        }),
        _createVNode(SkillCard, { name: "Node" }),
        _createVNode(SkillCard, { name: "Django" }),
        _createVNode(SkillCard, {
          name: "Kotlin",
          "add-radius": ""
        }),
        _createVNode(SkillCard, { name: "SQL" }),
        _createVNode(SkillCard, { name: "PostgreSQL" }),
        _createVNode(SkillCard, { name: "MongoDB" }),
        _createVNode(SkillCard, { name: "AWS" }),
        _createVNode(SkillCard, { name: "Firebase" })
      ])
    ])
  ]))
}
}

})